import Joi from "joi";
export const addRecordSchema = (lang) => {
  const language = lang === "AR" ? "arabic" : "english";
  const joiMessage = require(`../../translate/${language}/joi.json`);

  const schema = {
    initialData: {
      vendorPhoneNumber: null,
      vendorName: null,
      invoiceNumber: null,
      amount: null,
      payMethod: null,
      totalBoxs: null,
      totalPeices: null,
      NB: null,
      exchangeRateRMB: null,
      recordDate: null
    },
    schema: Joi.object({
      vendorPhoneNumber: Joi.string()
        .allow(null, "")
        .optional()
        .max(40)
        .messages({
          "string.base": joiMessage.exports_tab.add_record.vendorPhoneNumber.invalid,
          "string.max": joiMessage.exports_tab.add_record.vendorPhoneNumber.max,
        }),
      vendorName: Joi.string()
        .allow(null, "")
        .optional()
        .min(1)
        .max(40)
        .messages({
          "string.base": joiMessage.exports_tab.add_record.vendorName.invalid,
          "string.min": joiMessage.exports_tab.add_record.vendorName.min,
          "string.max": joiMessage.exports_tab.add_record.vendorName.max,
        }),
      invoiceNumber: Joi.string()
        .allow(null, "")
        .optional()
        .min(1)
        .max(40)
        .messages({
          "string.base":
            joiMessage.exports_tab.add_record.invoiceNumber.invalid,
          "string.min": joiMessage.exports_tab.add_record.invoiceNumber.min,
          "string.max": joiMessage.exports_tab.add_record.invoiceNumber.max,
        }),
      amount: Joi.number().positive().allow(0).required().messages({
        "number.empty": joiMessage.common.required,
        "number.base": joiMessage.exports_tab.add_record.amount.positve_number,
        "number.integer":
          joiMessage.exports_tab.add_record.amount.positve_number,
        "number.positive":
          joiMessage.exports_tab.add_record.amount.positve_number,
      }),
      payMethod: Joi.string().required().valid("on-us", "off-us").messages({
        "string.empty": joiMessage.common.required,
        "string.base": joiMessage.exports_tab.add_record.payMethod.invalid,
        "string.only": joiMessage.exports_tab.add_record.payMethod.invalid,
        "any.only": joiMessage.exports_tab.add_record.payMethod.required,
        "string.requied": joiMessage.exports_tab.add_record.payMethod.invalid,
      }),
      totalBoxs: Joi.number()
        .allow(null, "", NaN)
        .integer()
        .optional()
        .messages({
          "number.base": joiMessage.exports_tab.add_record.totalBoxs.count,
          "number.integer": joiMessage.exports_tab.add_record.totalBoxs.count,
        }),
      totalPeices: Joi.number()
        .allow(null, "", NaN)
        .integer()
        .optional()
        .messages({
          "number.base": joiMessage.exports_tab.add_record.totalBoxs.count,
          "number.integer": joiMessage.exports_tab.add_record.totalBoxs.count,
        }),
      exchangeRateRMB: Joi.number().required().allow(0).messages({
        "number.base": joiMessage.exports_tab.add_record.exchangeRateRMB.invalid,
        "number.empty": joiMessage.exports_tab.add_record.exchangeRateRMB.required,
      }),
      NB: Joi.string().allow(null, "").optional().min(1).max(254).messages({
        "string.base": joiMessage.exports_tab.add_record.notes.invalid,
        "string.min": joiMessage.exports_tab.add_record.notes.min,
        "string.max": joiMessage.exports_tab.add_record.notes.max,
      }),
      recordDate: Joi.date().required().messages({
        "date.base": joiMessage.exports_tab.add_record.recordDate.required,
        "string.invalid": joiMessage.exports_tab.add_record.recordDate.invalid
      })
    }),
    explicitCheck: {
      vendorName: false,
      invoiceNumber: false,
      amount: false,
      payMethod: false,
      totalBoxs: false,
      totalPeices: false,
      NB: false,
      recordDate: false
    },
    validationOptions: {
      abortEarly: true,
    },
  };
  return { schema: schema };
};

export const updateRecordSchema = (lang) => {
  const language = lang === "AR" ? "arabic" : "english";
  const joiMessage = require(`../../translate/${language}/joi.json`);

  const schema = {
    initialData: {
      vendorPhoneNumber: null,
      vendorName: null,
      invoiceNumber: null,
      amount: null,
      payMethod: null,
      totalBoxs: null,
      totalPeices: null,
      NB: null,
      exchangeRateRMB: null,
      recordDate: null
    },
    schema: Joi.object({
      vendorPhoneNumber: Joi.string()
        .allow(null, "")
        .optional()
        .max(40)
        .messages({
          "string.base": joiMessage.exports_tab.add_record.vendorPhoneNumber.invalid,
          "string.max": joiMessage.exports_tab.add_record.vendorPhoneNumber.max,
        }),
      vendorName: Joi.string()
        .allow(null, "")
        .optional()
        .min(1)
        .max(40)
        .messages({
          "string.base": joiMessage.exports_tab.add_record.vendorName.invalid,
          "string.min": joiMessage.exports_tab.add_record.vendorName.min,
          "string.max": joiMessage.exports_tab.add_record.vendorName.max,
        }),
      invoiceNumber: Joi.string()
        .allow(null, "")
        .optional()
        .min(1)
        .max(40)
        .messages({
          "string.base":
            joiMessage.exports_tab.add_record.invoiceNumber.invalid,
          "string.min": joiMessage.exports_tab.add_record.invoiceNumber.min,
          "string.max": joiMessage.exports_tab.add_record.invoiceNumber.max,
        }),
      amount: Joi.number()
        .allow(0, null, "", NaN)
        .positive()
        .optional()
        .messages({
          "number.base":
            joiMessage.exports_tab.add_record.amount.positve_number,
          "number.integer":
            joiMessage.exports_tab.add_record.amount.positve_number,
          "number.positive":
            joiMessage.exports_tab.add_record.amount.positve_number,
        }),
      payMethod: Joi.string()
        .allow(null, "")
        .optional()
        .valid("on-us", "off-us")
        .messages({
          "string.empty": joiMessage.common.required,
          "string.base": joiMessage.exports_tab.add_record.payMethod.invalid,
          "string.only": joiMessage.exports_tab.add_record.payMethod.invalid,
          "string.requied": joiMessage.exports_tab.add_record.payMethod.invalid,
        }),
      totalBoxs: Joi.number()
        .allow(null, "", NaN)
        .integer()
        .optional()
        .messages({
          "number.base": joiMessage.exports_tab.add_record.totalBoxs.count,
          "number.integer": joiMessage.exports_tab.add_record.totalBoxs.count,
        }),
      totalPeices: Joi.number()
        .allow(null, "", NaN)
        .integer()
        .optional()
        .messages({
          "number.base": joiMessage.exports_tab.add_record.totalBoxs.count,
          "number.integer": joiMessage.exports_tab.add_record.totalBoxs.count,
        }),
      exchangeRateRMB: Joi.number().allow(null, 0).messages({
        "number.base": joiMessage.exports_tab.add_record.exchangeRateRMB.invalid,
      }),
      NB: Joi.string().allow(null, "").optional().min(1).max(254).messages({
        "string.base": joiMessage.exports_tab.add_record.notes.invalid,
        "string.min": joiMessage.exports_tab.add_record.notes.min,
        "string.max": joiMessage.exports_tab.add_record.notes.max,
      }),
      recordDate: Joi.date().optional().allow(null).messages({
        "date.base": joiMessage.exports_tab.add_record.recordDate.invalid
      })
    }),
    explicitCheck: {
      vendorName: false,
      invoiceNumber: false,
      amount: false,
      payMethod: false,
      totalBoxs: false,
      totalPeices: false,
      NB: false,
      recordDate: false
    },
    validationOptions: {
      abortEarly: true,
    },
  };
  return { schema: schema };
};

export const payRecordSchema = (lang) => {
  const language = lang === "AR" ? "arabic" : "english";
  const joiMessage = require(`../../translate/${language}/joi.json`);

  const schema = {
    initialData: {
      invoiceAmount: null,
      exchangeRateRMB: null,
      recordDate: null,
      NB: null
    },
    schema: Joi.object({
      invoiceAmount: Joi.number().positive().allow(0).required().messages({
        "number.empty": joiMessage.common.required,
        "number.base":
          joiMessage.exports_tab.pay_record.invoiceAmount.positve_number,
        "number.integer":
          joiMessage.exports_tab.pay_record.invoiceAmount.positve_number,
        "number.positive":
          joiMessage.exports_tab.pay_record.invoiceAmount.positve_number,
      }),
      exchangeRateRMB: Joi.number().positive().required().allow(0).messages({
        "number.base": joiMessage.exports_tab.add_record.exchangeRateRMB.invalid,
        "number.empty": joiMessage.exports_tab.add_record.exchangeRateRMB.required,
        "number.positive":
          joiMessage.exports_tab.pay_record.invoiceAmount.positve_number,
      }),
      recordDate: Joi.date().required().messages({
        "date.base": joiMessage.exports_tab.add_record.recordDate.required,
        "string.invalid": joiMessage.exports_tab.add_record.recordDate.invalid
      }),
      NB: Joi.string().allow(null, "").optional().min(1).max(254).messages({
        "string.base": joiMessage.exports_tab.add_record.notes.invalid,
        "string.min": joiMessage.exports_tab.add_record.notes.min,
        "string.max": joiMessage.exports_tab.add_record.notes.max,
      })
    }),
    explicitCheck: {
      invoiceAmount: false,
      exchangeRateRMB: false,
      recordDate: false,
      NB: false
    },
    validationOptions: {
      abortEarly: true,
    },
  };
  return { schema: schema };
};
